<template>
  <v-overlay :value="loadingDownloadData" absolute opacity="0.1">
    <center>
      <img width="100" :src="require('@/assets/img/clock-time.gif')" />
      <div class="text-center" style="color: #077893">
        <h2 class="text-center"> {{ title }} </h2>
        <p>{{ detail }}</p>
      </div>
    </center>
  </v-overlay>
</template>
<script>
export default {
  props: ["title", "detail"],
  data: () => ({
    loadingDownloadData: true,
  }),
};
</script>
